import { useContext } from 'react';
import { formatDate } from '@gtintel/platform-utils';
import { ProjectContext } from '../../context';
import styles from './styles.module.scss';
const ProjectDetailsCard = () => {
  const ctx = useContext(ProjectContext);
  const clientPriceLabel = 'Price';
  const priceLabelPrepend = ' (Excluding VAT or other applicable taxes)';
  const id = ctx.projectId();
  const rawRequestedCompletionDate = ctx.requestedCompletionDate();
  const rawCreatedDate = ctx.createdDate();
  const clientPrice = ctx.clientPrice();
  const currency = ctx.currency();
  return <section className={styles.section}>
      <div className={styles.details}>
        <p>
          <span>Project ID: </span>
          {'#'}
          {id}
        </p>

        <p>
          <span>Project Type: </span>
          {ctx.projectType()}
        </p>

        {!!rawRequestedCompletionDate && <p>
            <span>Requested Completion Date: </span>{' '}
            {formatDate(rawRequestedCompletionDate)}
          </p>}

        {!!rawCreatedDate && <p>
            <span>Created Date: </span> {formatDate(rawCreatedDate)}
          </p>}

        <p>
          <span>{clientPriceLabel}: </span>
          {`${currency}${clientPrice}`}
          {priceLabelPrepend}
        </p>

        {ctx.data().description && <p>
            <span className={styles.h5}>Description: </span>
            {ctx.data().description}
          </p>}
      </div>
    </section>;
};
export default ProjectDetailsCard;